import { render } from "./studentAccommodationsModal.vue?vue&type=template&id=bee9a8ce&scoped=true"
import script from "./studentAccommodationsModal.vue?vue&type=script&lang=js"
export * from "./studentAccommodationsModal.vue?vue&type=script&lang=js"

import "./studentAccommodationsModal.vue?vue&type=style&index=0&id=bee9a8ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee9a8ce"]])

export default __exports__